/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import * as applicationStatuses from "../../services/contractLaw/applicationStatus";

const otherContractTranslations = {
  label: "Sonstiger Vertrag",
  ...abstractContractClaimTranslations,
};

export default otherContractTranslations;
